<template>
  <div class="timeline-table">   
    <table class="table">
      <thead>
      <tr>
        <th>Date/Time</th>
        <th>Client/Brand</th>
        <th>Campaign</th>
        <th>Board</th>
        <th>Creative</th>
        <th>Action</th>
        <th>Action By</th>
      </tr>
      </thead>
      <tbody v-if="timeline.length > 0">
      <tr v-for="t in timeline" :key="t.id">
        <td>{{ t.created_at }}</td>
        <td>{{ t.client_name }} / <br/> <strong>{{ t.brand_name }}</strong></td>
        <td>{{ t.campaign_name }}</td>
        <td>{{ t.board_name }}</td>
        <td>{{ t.creative_name }}</td>
        <td>{{ t.action }}</td>
        <td>{{ t.user_name }}</td>
      </tr>
      </tbody>
    </table>
    <div v-if="!timeline.length" class="empty-message empty-message--actions">No results.</div>
  </div>
</template>
<script>

export default ({

  props: ['timeline']
})
</script>
